import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { i18n } from '@shared/util/i18n';

export function NeedsCardFilter() {
  return (
    <View centerHorizontally centerVertically marginHorizontal={2} marginVertical={4}>
      <Text size="body1">{i18n('builder.relatedCardOptions.needsLinking')}</Text>
    </View>
  );
}
